<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('home.investment')}}</div>
			<div class="msg" @click="$router.push('/notice')">
				<img src="../images/invest/msg.png">
			</div>
		</div>
		<div class="item_wrap">
			<div class="intro-box">
				<div class="intro-title">{{$t('item.projectIntroduction')}}</div>
			</div>
				<div class="items_3">
				<van-empty v-if="listLength == 0" :description="$t('item.noData')" />
				<div v-for="i in data.list" :key="i.id" class="item" :class="{ item_can_invest: toBool(i.can_invest), item_locked: !toBool(i.can_invest) }">
					<div class="item_div1" >
						<!-- @click="$router.push('/item/'+i.id)" -->

						<img v-if="i.cover" class="icon round" :src="i.cover" alt="">
						<img v-else class="icon round" src="../images/invest/bi.png" alt="">
						<p>
							{{ i[lang] }}
						</p>
					</div>
					<div class="item_div2">
						 <!-- @click="$router.push('/item/'+i.id)" -->
						<div class="item_rate">
							<p>{{i.rate}}%</p>
							<p>{{$t('utils.dailyIncome')}}</p>
						</div>
						<div class="item_day">
						<p>{{ getDayLabel(i.investment_type) }}</p>
						<button type="button" class="cycle-btn" @click="cycleDay(i)">{{ $t('utils.investmentOptions') }}</button>
						</div>
						<div class="item_min">
							<!-- <p>{{i.min}}-{{ i.max }}</p>num_text -->
							<p>{{i.num_text}}</p>
							<p>{{$t('utils.investmentAmount')}}</p>
						</div>
					</div>
					<div class="item_div3">
						<!-- <span>{{$t('utils.scale')}}:{{i.total}}</span> -->
						<!-- <span>   按日收益，到期还本</span> -->
					</div>
					<div class="item_div4">
						<div class="my-investment">
							<span class="label">{{$t('home.myInvestment')}}：</span>
							<span class="value">{{i.investment}}</span>
						</div>
					<div class="item_btn">
						<button type="button" :class="{'item_btn_over': !isWithdrawReady(i), 'item_btn_ready': isWithdrawReady(i)}" @click="sell(i)">提取</button>
					</div>
						
					<div  class="item_btn">
						<button type="button" :disabled="isInvestDisabled(i)" :class="{'item_btn_over': isInvestDisabled(i), 'item_btn_ready': isInvestReady(i) }" @click="buy(i)">{{$t('utils.invest')}}</button>
					</div>
					</div>
				</div>
			</div>
			<van-dialog v-model="show_tz" theme="round-button" get-container="body"
				:before-close="onDialogBeforeClose"
				:confirmButtonText="$t('utils.confirm')">
				<div class="show-body">
					<div class="close-x" @click.stop="show_tz = false">
						<van-icon name="cross" />
					</div>
					<div class="sw-cell">
						<div class="sw-label">{{ sku[lang] }}</div>
						<div class="sw-bar">
							<div class="flex_bd">
								<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')" />
							</div>
							<div class="ut">USDT</div>
						</div>
					</div>
					<div class="sw-grid">
						<div class="flex_bd">
							<div class="sw-row">
								<div class="sw-info">{{$t('utils.yuji_sy')}}</div>
								<div class="sw-val">{{(sku.rate*number/100).toFixed(5)}}</div>
							</div>
							<div class="sw-row">
								<div class="sw-val text-green">{{sku.rate}}% [ USD ]</div>
								<div class="sw-info">{{$t('utils.cankao_info')}}</div>
							</div>
						</div>
						<div class="sw-right">
							<div class="sw-label">USDT</div>
							<div class="sw-lg">{{sku.day}}{{$t('utils.day')}}</div>
							<div class="sw-info">{{$t('utils.cycle')}}</div>
						</div>
					</div>
					<div class="sw-end">
						<div class="flex_bd">
							{{$t('utils.tz_auto')}}
						</div>
						<van-switch v-model="checked"  @change="changeAuto" active-color="#ff6034" inactive-color="#dcdee0" size="24px" />
					</div>
				</div>
				<!-- <div class="items_3">
					<div class="item">
						<div class="item_div1">
							<img src="../images/invest/bi.png" class="icon" alt="">
							<p>
								{{ sku[lang] }}
							</p>
						</div>
						<div class="item_div2">
							<div class="item_rate">
								<p>{{sku.rate}}%</p>
								<p>{{$t('utils.dailyIncome')}}</p>
							</div>
							<div class="item_day">
								<p>{{sku.day}}{{$t('utils.day')}}</p>
								<p>{{$t('utils.cycle')}}</p>
							</div>
							<div class="item_min">
								<p>{{$t('utils.moneyMark')}}{{sku.min}}</p>
								<p>{{$t('utils.startingAmount')}}</p>
							</div>
						</div>
					</div>
				</div> -->
			</van-dialog>
			<van-popup v-model="showDaySheet" position="bottom" round :z-index="3000" get-container="body">
				<div class="day-sheet">
					<div
						v-for="action in daySheetActions"
						:key="action.value"
						class="day-sheet-item"
						@click="onSelectDay(action)"
					>{{ action.name }}</div>
					<div class="day-sheet-gap"></div>
					<div class="day-sheet-cancel" @click="showDaySheet = false">{{ $t('utils.cancel') }}</div>
				</div>
			</van-popup>
			
			<!-- VIP升级规则说明 -->
			<!-- <div class="vip-rules-section">
				<div class="vip-rules-title">VIP升级规则说明</div>
				<div class="vip-rules-note">注：以上利率均为日利率，级别升级方式如下：</div>
				<div class="vip-rules-list">
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP2</span>
						<span class="vip-requirement">需要满足：直推4个V1，自身绑定500-1000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP3</span>
						<span class="vip-requirement">需要满足：直推4个V2，自身绑定1000-3000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP4</span>
						<span class="vip-requirement">需要满足：直推4个V3，自身绑定3000-10000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP5</span>
						<span class="vip-requirement">需要满足：直推4个V4，自身绑定10000-30000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP6</span>
						<span class="vip-requirement">需要满足：直推4个V5，自身绑定30000-100000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP7</span>
						<span class="vip-requirement">需要满足：直推4个V6，自身绑定100000-300000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级VIP8</span>
						<span class="vip-requirement">需要满足：直推4个V7，自身绑定300000-1000000</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级也太合伙人</span>
						<span class="vip-requirement">需要满足：直推4个V6，自身绑定1000000以上</span>
					</div>
					<div class="vip-rule-item">
						<span class="vip-level">升级也太合伙人</span>
						<span class="vip-requirement">需要满足：直推4个V7，自身绑定2000000以上</span>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>
<script>
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import Vue from 'vue';
	import {
		Tab,
		Tabs,
		Progress,
		Empty,
		Dialog,
		Field,
		Sticky,
		Switch,
		Popup
	} from 'vant';
	Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Sticky).use(Switch).use(Popup);
	export default {
		name: "item",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				tabs: [
					this.$t('item.all'),
					this.$t('item.tab1'),
					this.$t('item.tab2'),
					this.$t('item.tab3'),
					this.$t('item.tab4'),
					this.$t('item.tab5')
				],
				tabs1: [{
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.all')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab1')
				}, {
					icon: require('../images/invest/icon3.png'),
					title: this.$t('item.tab2')
				}, {
					icon: require('../images/invest/icon4.png'),
					title: this.$t('item.tab3')
				}, {
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.tab4')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab5')
				}],
				active: 0,
				auto_close: [],
				data: [],
				listLength: 0,
				userVip: '',
				show_tz: false,
				number: "",
				sku: [],
				checked: true,
				showDaySheet: false,
				currentDayItem: null,
				submitting: false,
				daySheetActions: [
					{ name: '复投本金利润', value: 1 },
					{ name: '提现利润,本金复投', value: 2 },
					{ name: '提取本金和利润', value: 3 },
				],
			}
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			var type = 0;
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			this.start(type);
		},
		activated() {
			this.start(this.active || 0);
		},
		methods: {
			getInvestTypePrefs() {
				try {
					return JSON.parse(localStorage.getItem('invest_type_prefs') || '{}');
				} catch (e) {
					return {};
				}
			},
			saveInvestTypePref(itemId, type) {
				const prefs = this.getInvestTypePrefs();
				prefs[itemId] = type;
				localStorage.setItem('invest_type_prefs', JSON.stringify(prefs));
			},
			applyInvestTypePrefs(list) {
				const prefs = this.getInvestTypePrefs();
				list.forEach((item) => {
					if (this.toNumber(item.investment) <= 0 && prefs[item.id]) {
						item.investment_type = prefs[item.id];
					}
				});
			},
			toNumber(val){
				if (typeof val === 'number') return val;
				if (val === null || val === undefined) return 0;
				var n = parseFloat(val);
				return isNaN(n) ? 0 : n;
			},
			toBool(val){
				if (typeof val === 'boolean') return val;
				if (val === 1 || val === '1' || val === 'true' || val === 'TRUE') return true;
				return false;
			},
			isInvestReady(item){
				return this.toBool(item.can_invest) && !this.isInvestDisabled(item);
			},
			isInvestDisabled(item){
				const investment = this.toNumber(item.investment);
				const max = this.toNumber(item.max);
				const canInvest = this.toBool(item.can_invest);
				return investment >= max || !canInvest;
			},
			isWithdrawReady(item){
				const investment = this.toNumber(item.investment);
				if (investment <= 0) return false;
				if (item.can_withdraw === false || item.can_withdraw === 0 || item.can_withdraw === '0') {
					return false;
				}
				return true;
			},
			isWithdrawDisabled(item){
				return !this.isWithdrawReady(item);
			},
			start(type) {
				Fetch('/index/item_search', {
					name: "",
					index_type: type
				}).then(r => {
					const list = r.data.list || [];
					this.userVip = r.data.user_vip || '';
					this.applyInvestTypePrefs(list);
					this.data = { list: list };
					this.listLength = list.length;
				})
				Fetch('/index/item_auto').then((r) => {
					for (var i = 0; i < r.data.ids.length; i++) {
						this.auto_close.push(parseInt(r.data.ids[i]));
					}
				});
			},
			sort(type) {
				this.active = type
				this.start(type);
			},
			changeAuto(e)
			{
				console.log(e)
				Fetch("/index/item_auto_c", {
				  pid: this.sku.id,
				  tz_auto: this.checked?1:0
				}).then(r => { 
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
			getDayLabel(day) {
				if (day === 1) {
					return '复投本金利润';
				}
				if (day === 2) {
					return '提现利润,本金复投';
				}
				if (day === 3) {
					return '提取本金和利润';
				}
				return '';
			},
			cycleDay(item) {
				this.currentDayItem = item;
				this.showDaySheet = true;
			},
			onSelectDay(action) {
				if (!this.currentDayItem || !action) return;
				this.$set(this.currentDayItem, 'investment_type', action.value);
				this.saveInvestTypePref(this.currentDayItem.id, action.value);
				this.showDaySheet = false;

				Fetch('/index/update_item_type', {
					id: this.currentDayItem.id,
					type: action.value
				}).then(r => {
					this.$toast({
						className: "toastName",
						message: '设置成功',
						type: 'success'
					});
					this.start(0);
				}).catch(err => {
					this.$toast({
						className: "toastName",
						message: '已保存，投资后生效',
						type: 'success'
					});
				});

				this.currentDayItem = null;
			},
			buy(item) {
				if (!this.toBool(item.can_invest)) {
					this.$toast({
						className: 'toastName',
						message: '请先升级至对应VIP等级后再投资',
					});
					return;
				}
				const investment = this.toNumber(item.investment);
				const max = this.toNumber(item.max);
				if (investment >= max && max > 0) {
					this.$toast({
						className: 'toastName',
						message: '该项目投资额度已满',
					});
					return;
				}
				this.sku = item;
				this.number = '';
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;
			},
			onDialogBeforeClose(action, done) {
				if (action !== 'confirm') {
					done();
					return;
				}
				const amount = parseFloat(this.number);
				if (!this.number || isNaN(amount) || amount <= 0) {
					this.$toast({
						className: 'toastName',
						message: this.$t('item.inputAmount'),
					});
					done(false);
					return;
				}
				if (this.submitting) {
					done(false);
					return;
				}
				this.submitting = true;
				Fetch("/index/item_apply", {
					id: this.sku.id,
					money: this.number,
					day: this.sku.investment_type || 1
				}).then(() => {
					this.submitting = false;
					this.$toast({
						className: 'toastName',
						message: '投资成功',
						type: 'success'
					});
					this.number = '';
					this.start(0);
					done();
				}).catch(() => {
					this.submitting = false;
					done(false);
				});
			},
			sell(item) {
				if (this.isWithdrawDisabled(item)) {
					if (this.toNumber(item.investment) > 0 && (item.can_withdraw === false || item.can_withdraw === 0 || item.can_withdraw === '0')) {
						const planName = item[this.lang] || item.zh_cn || '该项目';
						this.$toast({
							className: 'toastName',
							message: planName + '未满24小时，暂不可提取',
						});
					}
					return;
				}
				const amount = this.toNumber(item.investment);
				const revenue = this.toNumber(item.revenue);
				const type = item.investment_type || 1;
				const tips = {
					1: '本金和利润将继续复投托管',
					2: '利润已提现至余额，本金继续托管',
					3: '本金和利润已全部提现至余额',
				};
				Dialog.confirm({
					title: this.$t ? this.$t('utils.confirm') : '确认提取吗？',
					message: `投资金额：${amount}  利润：${revenue.toFixed(2)}`
				}).then(() => {
					Fetch('/index/item_sell', {
						id: item.id
					}).then(r => {
						this.$toast.success(tips[type] || '提取成功');
						this.start(0);
					}).catch(err => {});
				}).catch(() => {});
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .van-cell {
		padding: 15px 26px;
	}

	.tabs {
		background-color: #fff;
		padding: 16px 0 10px 0;
		border-bottom: 1px solid #ececec;
		position: fixed;
		width: 100%;
	}

	.tabs-head {
		height: 73px;
		overflow: hidden;
		position: relative;

		.tabs-head-scroll {
			width: 100%;
			height: 80px;
			overflow: scroll;
			white-space: nowrap;

			.tab-item {
				display: inline-block;
				text-align: center;
				width: 25%;
				// margin-right: 28px;

				.tab-icon {
					height: 51px;

					img {
						height: 100%;
					}
				}

				.tab-title {
					padding: 5px 0;
					color: #666666;
				}
			}

			.tab-item-active {
				.tab-title {
					color: #333333;
				}
			}
		}
	}

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		background-image: linear-gradient(to right, #ff5252, #ff8244);

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;

			img {
				height: 100%;
			}
		}
	}

	.basic_wrap {
		position: relative;
	}

	.item_wrap {
		width: 100%;
		padding: 44px 0 0 0;

		.tabs { z-index: 100; }
		.intro-box{
			background: #fff;
			padding: 12px 14px 10px;
			border-bottom: 1px solid #ececec;
			position: sticky;
			top: 44px;
			z-index: 100;
			.intro-title{font-size: 15px;font-weight: bold;margin-bottom: 6px;}
			.intro-content{font-size: 12px;color:#666;line-height: 1.7;}
		}
	}



	.items_3 {
		margin: 10px 15px;

		.item {
			background: #FFFFFF;
		}
	}

	.items_3 {
		.item {
			margin-bottom: 10px;
			border-radius: 10px;
			overflow: hidden;
			border: 1px solid #ebebeb;
			box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);

			&.item_locked {
				opacity: 0.55;
			}

			&.item_can_invest {
				opacity: 1;
				border-color: #f5c4c2;
			}

			&.item_locked {
				opacity: 0.55;
			}

			// div{
			// 	margin: 5px 0;
			// }
			.item_div1 {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #ECECEC;
				padding: 4px 10px;
				background-color: #f5f5f5;

				p:nth-child(2) {
					// width: 90%;
					font-weight: bold;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 15px;

				}

				p:nth-child(3) {
					color: #999;
				}

				.icon {
					width: 32px;
					height: 32px;
					margin-right: 8px;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				padding: 12px 0;
				font-size: 14px;

				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}

				.item_day {
					p:nth-child(1) {
						font-weight: bold;
						font-size: 15px;
					}

					.cycle-btn {
						color: #999;
						font-size: 12px;
						background: transparent;
						border: none;
						padding: 5px 0;
						cursor: pointer;
					}
				}

				.item_min {
					p:nth-child(1) {
						font-weight: bold;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 0 12px;
			}

			.item_div4 {
				padding: 0 12px 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.my-investment{
					font-size: 13px;
					line-height: 1;
					color: #666;
					
					.label{color:#999;}
					.value{color:#e82637;font-weight: bold;margin-left: 2px;}
				}


				.item_progress {
					width: 71%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					background-color: #e9e9e9;
					padding: 0 4px;
					border-radius: 12px;

					.progress_bd {
						width: 75%;
					}

					span {
						color: #e82637;
					}

				}

				.item_btn {
					width: 24%;
					text-align: right;

					button {
						min-width: 65px;
						color: #f44844;
						padding: 6px;
						border-radius: 5px;
						font-size: 13px;
						border: 1px solid #e82637;
					}

					.item_btn_over {
						color: #999;
						border: 1px solid #999;
						background: transparent;
					}

					.item_btn_ready {
						background: #e82637;
						color: #fff;
						border: 1px solid #e82637;
					}
				}
			}
		}
	}

	/deep/ .van-tabs__line {
		height: 2px;
		background-color: #1989fa;
	}

	/deep/ .van-tab--active {
		color: #1989fa;
	}

	.show-body {
		padding: 20px;
		font-size: 14px;
		position: relative;

		.close-x {
			color: #999;
			position: absolute;
			right: 0;
			top: -8px;
			z-index: 2;
			padding: 8px;
		}

		.sw-label {
			margin-bottom: 10px;
		}

		.sw-bar {
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;

			.flex_bd {
				color: #999999;
			}
		}
	}

	.sw-bar .van-cell {
		padding: 0;
		background-color: transparent;
	}

	.sw-grid {
		display: flex;
		align-items: flex-end;
		margin-top: 20px;

		.sw-row:first-child {
			margin-bottom: 20px;
		}

		.sw-row>div:first-child {
			margin-bottom: 10px;
		}

		.sw-info {
			color: #999;
		}

		.sw-val.text-green {
			font-size: 16px;
		}
	}

	.sw-right {
		text-align: center;

		.sw-lg {
			font-size: 24px;
			margin-bottom: 10px;
		}
	}

	.flex_bd {
		flex: 1;
	}

	.day-sheet {
		background: #fff;
		padding-bottom: env(safe-area-inset-bottom);
	}

	.day-sheet-item,
	.day-sheet-cancel {
		display: block;
		width: 100%;
		padding: 16px;
		font-size: 16px;
		line-height: 22px;
		text-align: center;
		background: #fff;
		border: none;
		color: #323233;
		cursor: pointer;
		box-sizing: border-box;
	}

	.day-sheet-item:active,
	.day-sheet-cancel:active {
		background: #f2f3f5;
	}

	.day-sheet-item + .day-sheet-item {
		border-top: 1px solid #f5f5f5;
	}

	.day-sheet-gap {
		height: 8px;
		background: #f7f8fa;
	}

	.day-sheet-cancel {
		color: #646566;
	}

	.vip-rules-section {
		margin: 20px 15px;
		background: #fff;
		border-radius: 10px;
		padding: 15px;
		border: 1px solid #ebebeb;
		box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);

		.vip-rules-title {
			font-size: 16px;
			font-weight: bold;
			color: #333;
			margin-bottom: 10px;
			text-align: center;
		}

		.vip-rules-note {
			font-size: 13px;
			color: #666;
			margin-bottom: 15px;
			text-align: center;
		}

		.vip-rules-list {
			.vip-rule-item {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				padding: 8px 0;
				border-bottom: 1px solid #f0f0f0;

				&:last-child {
					border-bottom: none;
				}

				.vip-level {
					font-size: 14px;
					font-weight: bold;
					color: #ff5252;
					min-width: 100px;
					flex-shrink: 0;
				}

				.vip-requirement {
					font-size: 13px;
					color: #666;
					line-height: 1.4;
					flex: 1;
					margin-left: 10px;
				}
			}
		}
	}
</style>
